import { css } from 'styled-components';
import color from './color';

const focusStyle = () => css`
  outline: 2px solid ${color('primary', 20)};
  outline-offset: 3px;
`;

export default focusStyle;
